import { patchRequest } from 'utils/api/apiRequest'

export const removeItem = (cart_item_id: string) => patchRequest('/redemption-site/cart/remove', { cart_item_id })
